// @ts-ignore
const noop = () => ({});

if (process.env.NODE_ENV !== "development") {
  console.log = noop;
  console.warn = noop;
  console.error = noop;
}



// WEBPACK FOOTER //
// ./src/polyfills/hideLogs.ts